<template>
  <el-main class="main_content" style="padding: 0">
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>用户管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/normal_user_list')">app用户管理</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form class="m-search" size="small" :model="filters">
          <el-row>
            <el-col :span="8">
              <el-form-item label="关键字">
                <el-input style="width:300px" v-model="filters.title" placeholder="请输入昵称、公司名称或者手机号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item>
                <el-button type="primary" @click="handleSearch">搜索</el-button>
                <el-button v-if="hasPower('40021991')" type="success" @click="addPostDialog">新增</el-button>
                <el-button v-if="hasPower('40021991')" type="success" @click="upTool">挂等级</el-button>
                <el-button type="success" @click="excelOut">导出</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <el-form-item label="用户状态">
                <el-select clearable v-model="filters.status" placeholder="请选择">
                  <el-option label="可用" value="1"></el-option>
                  <el-option label="禁用" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="代理类型">
                <el-select clearable v-model="filters.roleType" placeholder="请选择">
                  <el-option label="无" value="-1"></el-option>
                  <el-option label="康减系列vip会员" value="-0.5"></el-option>
                  <el-option label="康减系列高级会员" value="-0.4"></el-option>
                  <el-option label="康减系列荣誉会员" value="-0.3"></el-option>

                  <el-option label="康减系列市代" value="1.1"></el-option>
                  <el-option label="康减系列省代" value="2.1"></el-option>
                  <el-option label="康减系列CEO" value="3.1"></el-option>

                  <el-option label="VIP门店" value="0"></el-option>
                  <el-option label="联盟店" value="1"></el-option>
                  <el-option label="优秀联盟店" value="1.05"></el-option>
                  <el-option label="市代" value="2"></el-option>
                  <el-option label="省代" value="3"></el-option>
                  <el-option label="CEO" value="4"></el-option>
                  <el-option label="总经销商" value="5"></el-option>
                  <el-option label="销售公司" value="6"></el-option>

                  <el-option label="合伙人" value="2.2"></el-option>
                  <el-option label="董事" value="4.2"></el-option>
                <el-option label="经销商" value="4.8"></el-option>
                  <el-option label="区域总监" value="5.1"></el-option>
                  <el-option label="城市加盟商" value="5.2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="是否特殊身份">
                <el-select clearable v-model="filters.specialStatus" placeholder="请选择">
                  <el-option label="不是" value="1"></el-option>
                  <el-option label="是" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="用户类型">
                <el-select clearable v-model="filters.user_type" placeholder="请选择">
                  <el-option label="个人" value="1"></el-option>
                  <el-option label="企业" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

             <el-col :span="6">
              <el-form-item label="是否束轩">
                <el-select clearable v-model="filters.isSu" placeholder="请选择">
                  <el-option label="不是" value="2"></el-option>
                  <el-option label="是" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <!-- <el-form-item label="团队">
                <el-select clearable v-model="filters.groupType" placeholder="请选择">
                  <el-option label="陈" value="1"></el-option>
                  <el-option label="孙" value="2"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item
                v-if="ppD != null"
                label="所在省"
                prop="province"
              >
                <el-select
                  clearable
                  v-model="filters.province"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="option in provinceOptions"
                    :value="option"
                    :key='option'
                    :label="option"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="6">
              <el-form-item label="省代类型">
                <el-select clearable v-model="filters.provinceType" placeholder="请选择" @change="changeProvinceType">
                  <el-option label="优秀省代" value="1"></el-option>
                  <el-option label="战略省代" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head"></div>
        <el-table
          :data="tableData"
          v-loading="tableDataLoading"
          style="width: 100%"
          :height="tableHeight"
          :header-cell-class-name="objectSpanMethod"
        >
          <el-table-column prop="username" label="用户昵称">
            <template slot-scope="scope">
              <a
                style="color:blue;cursor: pointer;"
                @click="goDetail(scope.row)"
              >{{scope.row.username}}</a>
            </template>
          </el-table-column>

          <el-table-column label="用户头像">
            <template slot-scope="scope">
              <img :src="scope.row.user_head" style="width:50px;" />
            </template>
          </el-table-column>
          <el-table-column prop="telephone" label="手机号"></el-table-column>
          <!-- <el-table-column prop="chat_status" label="绑定微信">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.chat_status == 2" type="success" disable-transitions>是</el-tag>
              <el-tag v-if="scope.row.chat_status == 1" disable-transitions>否</el-tag>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="email" label="性别">
            <template slot-scope="scope">
              <span v-if="scope.row.sex == 1">男</span>
              <span v-if="scope.row.sex == 2">女</span>
            </template>
          </el-table-column> -->
          <el-table-column :formatter="formatterRoleType" prop="role_type" label="代理级别"></el-table-column>

          <!-- <el-table-column
            prop="group_type"
            label="团队"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.group_type == 1">陈</span>
            <span v-else>孙</span>
          </template>
          </el-table-column> -->
          <el-table-column prop="recommend_code" label="推荐码"></el-table-column>

          <el-table-column prop="id_code" label="实名信息">
            <template slot-scope="scope">
              <span
                v-if="scope.row.real_name != null && scope.row.real_name != ''"
              >{{scope.row.real_name}} - {{scope.row.id_code}}</span>
              <span v-if="scope.row.real_name == null || scope.row.real_name == ''">未认证</span>
            </template>
          </el-table-column>

          <el-table-column prop="balance" label="余额"></el-table-column>
          <el-table-column prop="send_score" label="积分">
            <template slot-scope="scope">
              <div>{{send_score ? send_score : 0}}</div>
            </template>
          </el-table-column>
          
          <!-- <el-table-column prop="red_balance" label="红包余额"></el-table-column> -->

          <el-table-column prop="deposit" label="保证金">
            <template slot-scope="scope">
              <span
                v-if="scope.row.deposit != null && (scope.row.deposit_need == null || scope.row.deposit >= scope.row.deposit_need)"
              >{{scope.row.deposit}}</span>
              <span
                v-if="scope.row.deposit != null && scope.row.deposit < scope.row.deposit_need"
                style="color:red"
              >{{scope.row.deposit}}(缺：{{(scope.row.deposit_need-scope.row.deposit).toFixed(2)}})</span>
              <span v-if="scope.row.deposit == null">无</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="up_name" label="上级代理"></el-table-column>

          <el-table-column prop="top_name" label="上上级代理"></el-table-column> -->

          <!-- <el-table-column prop="second_up_name" label="第二上级代理"></el-table-column>

          <el-table-column prop="second_top_name" label="第二上上级代理"></el-table-column> -->

          <el-table-column prop="recommen_name" label="推荐人"></el-table-column>

          <el-table-column prop="show_name" label="店铺名称"></el-table-column>

          <el-table-column prop="show_name" label="店铺地址" width="200">
            <template
              slot-scope="scope"
            >{{scope.row.shop_pro}}{{scope.row.shop_city}}{{scope.row.shop_dis}}{{scope.row.shop_detail}}</template>
          </el-table-column>

          <!-- <el-table-column label="身份证正面">
            <template slot-scope="scope">
              <el-popover
                placement="top"
                title=""
                trigger="hover"
              >
                <img
                  style="max-height: 200px;max-width: 200px"
                  :src="scope.row.id_front_pic"
                />
                <img
                  slot="reference"
                  :src="scope.row.id_front_pic"
                  :alt="scope.row.id_front_pic"
                  style="max-height: 50px;max-width: 130px"
                >
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column label="身份证反面">
            <template slot-scope="scope">
              <el-popover
                placement="top"
                title=""
                trigger="hover"
              >
                <img
                  style="max-height: 200px;max-width: 200px"
                  :src="scope.row.id_back_pic"
                />
                <img
                  slot="reference"
                  :src="scope.row.id_back_pic"
                  :alt="scope.row.id_back_pic"
                  style="max-height: 50px;max-width: 130px"
                >
              </el-popover>
            </template>
          </el-table-column>-->

          <el-table-column prop="create_time" label="注册时间"></el-table-column>

          <el-table-column prop="status" :formatter="formatterStatus" label="状态"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-dropdown v-if="hasPower('40021991')" @command="handleCommand">
                <span class="el-dropdown-link">
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">

                  <el-dropdown-item
                    v-if="scope.row.user_type==2 && scope.row.company_status < 7"
                    command="qq"
                    @click.native="companyInfoSet(scope.row)"
                  >企业认证</el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.status==2"
                    command="a"
                    @click.native="upHouseStatus(scope.row, 1)"
                  >恢复</el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.status==1"
                    command="b"
                    @click.native="upHouseStatus(scope.row, 2)"
                  >禁用</el-dropdown-item>
                  <el-dropdown-item
                    command="b"
                    @click.native="upHouseStatus(scope.row, 3)"
                  >重置密码</el-dropdown-item>
                  <!-- <el-dropdown-item
                    v-if="scope.row.role_type == 3"
                    command="c"
                    @click.native="setCeoNew(scope.row)"
                  >设置ceo</el-dropdown-item> -->
                  <el-dropdown-item
                    v-if="scope.row.role_type > 1 || (scope.row.deposit != null && scope.row.deposit > 0)"
                    command="d"
                    @click.native="showEditGroup2(scope.row)"
                  >修改真实保证金</el-dropdown-item>
                  <el-dropdown-item
                  v-if="scope.row.role_type > 1 || (scope.row.deposit != null && scope.row.deposit > 0)"
                    command="d"
                    @click.native="showEditGroup(scope.row)"
                  >修改需要交的保证金</el-dropdown-item>
                  <!-- <el-dropdown-item v-if="scope.row.open_status > 1" command="jk" @click.native="showChangeRealInfo(scope.row)">重新实名</el-dropdown-item> -->
                  <!-- v-if="scope.row.role_type != -1" -->
                  <!-- <el-dropdown-item command="e" @click.native="showEditGrou1p(scope.row)">修改余额</el-dropdown-item> -->
                  <el-dropdown-item command="f" @click.native="goEditPage(scope.row)">修改基本信息</el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.role_type > 1 && scope.row.role_type != 1.1 && scope.row.role_type != 5.1 && scope.row.role_type != 6"
                    command="c"
                    @click.native="downRoleType(scope.row)"
                  >降级</el-dropdown-item>
                  <el-dropdown-item
                  v-if="scope.row.role_type != 6"
                    command="c"
                    @click.native="editUpInfo(scope.row)"
                  >修改上级</el-dropdown-item>
                  <el-dropdown-item
                    command="cc"
                    @click.native="showEditGroup3(scope.row)"
                  >互换通联账户</el-dropdown-item>
                  <!-- <el-dropdown-item  command="i" @click.native="setterGroupInfo(scope.row)">设置团队</el-dropdown-item> -->


                   <!-- <el-dropdown-item v-if="scope.row.role_type == 3 && scope.row.province_type == 1" command="c" @click.native="upHouseStatus(scope.row, 6)">改为战略省代</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.role_type == 3 && scope.row.province_type == 2" command="c" @click.native="upHouseStatus(scope.row, 7)">改为优秀省代</el-dropdown-item> -->

                  <el-dropdown-item v-if="scope.row.balance==0" command="c" @click.native="delNormalUser(scope.row)">销户</el-dropdown-item>
                  <!-- (scope.row.deposit == null || scope.row.deposit <= 0) && scope.row.balance > 0 &&  -->
                  <el-dropdown-item v-if="scope.row.del_status == 1" command="c" @click.native="upHouseStatus(scope.row, 4)">改为待销户</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.del_status == 2" command="c" @click.native="upHouseStatus(scope.row, 5)">改为正常户</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.role_type == 4.2" command="cde" @click.native="upHouseStatus(scope.row, 8)">改为城市加盟商</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <!-- <template v-if="scope.row.status==2">
                <el-button
                  @click="upHouseStatus(scope.row, 1)"
                  type="text"
                >恢复</el-button>
              </template>
              <template v-if="scope.row.status==1">
                <el-button
                  @click="upHouseStatus(scope.row, 2)"
                  type="text"
                >禁用</el-button>
              </template>

              <el-button
                v-if="scope.row.role_type != 0 && scope.row.role_type != 4"
                @click="showEditGroup1(scope.row)"
                type="text"
              >设置ceo</el-button>

              <el-button
                v-if="scope.row.role_type != 0"
                @click="showEditGroup(scope.row)"
                type="text"
              >修改保证金</el-button>

              <el-button
                v-if="scope.row.role_type != 0"
                @click="showEditGroup(scope.row)"
                type="text"
              >修改余额</el-button>

              <el-button
                @click="goEditPage(scope.row)"
                type="text"
              >修改信息</el-button>-->
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count="total_page"
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          ></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="修改余额" :visible.sync="dialogBalanceVisible" width="20%">
      <el-form
        label-position="top"
        class="m-search"
        size="small"
        :rules="balanceFormRule"
        :model="balanceForm"
        ref="balanceForm"
      >
        <el-form-item label="类型" prop="status">
          <el-select v-model="balanceForm.status" placeholder="请选择">
            <el-option label="加" value="1"></el-option>
            <el-option label="减" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="余额" prop="money">
          <el-input
            v-model="balanceForm.money"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请输入大于0的金额，不能输入字符串"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="throwGroupUp2()" :loading="addBalanceLoading">提交</el-button>
          <el-button @click="dialogBalanceVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="互换通联账户" :visible.sync="dialogEditVisible3" width="40%">
      <el-form label-position="top" class="m-search" size="small" :model="form" ref="form">

        <el-form-item label="互换用户手机号">
          <el-input
            v-model="form.telephone"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请输入手机号"
          ></el-input>
          <span style="color:red">注意事项：1请检查是否有正在申请提现的记录，2互换成功后，两个账户收款和余额等信息会互换，请谨慎操作</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="throwGroupUp23()" :loading="addLoading3">提交</el-button>
          <el-button @click="dialogEditVisible3 = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="修改真实保证金" :visible.sync="dialogEditVisible2" width="20%">
      <el-form label-position="top" class="m-search" size="small" :model="form" ref="form">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option label="加" value="1"></el-option>
          <el-option label="减" value="2"></el-option>
        </el-select>
        <el-form-item label="保证金">
          <el-input
            v-model="form.deposit"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请输入金额，不能输入字符串"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="throwGroupUp22()" :loading="addLoading2">提交</el-button>
          <el-button @click="dialogEditVisible2 = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="修改所需保证金" :visible.sync="dialogEditVisible" width="20%">
      <el-form label-position="top" class="m-search" size="small" :model="form" ref="form">
        <el-form-item label="保证金">
          <el-input
            v-model="form.deposit"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请输入金额，不能输入字符串"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="throwGroupUp()" :loading="addLoading">提交</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="重新实名" :visible.sync="dialogRealEditVisible" width="20%">
      <el-form label-position="top" class="m-search" size="small" :model="formReal" ref="formReal">
        <el-form-item label="新手机号">
          <el-input
            v-model="formReal.telephone"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="formReal.balance > 0" label="验证码">
          <el-input
            v-model="formReal.identy"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getChangeMoneyI()" :loading="addRealEditLoading1">获取验证码</el-button>
          <el-button type="primary" :disabled="formReal.myCode == null || formReal.identy == null" @click="changeRealInfo()" :loading="addRealEditLoading">提交</el-button>
          <el-button @click="dialogRealEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="设置团队" :visible.sync="dialogGroupEditVisible" width="20%">
      <el-form label-position="top" class="m-search" size="small" :model="groupForm" ref="groupForm">
        <el-form-item label="团队 ">
          <el-select v-model="groupForm.groupType" placeholder="请选择">
            <el-option label="陈" value="1"></el-option>
            <el-option label="孙" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setterGroupForm()" :loading="addGroupLoading">提交</el-button>
          <el-button @click="dialogGroupEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="设置CEO" :visible.sync="dialogCEOVisible" width="40%">
      <el-form label-position="top" class="m-search" size="small" :model="form1" ref="form1">
        <el-form-item label="增加保证金">
          <el-input
            v-model="form1.deposit"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请输入金额，不能输入字符串"
          ></el-input>
        </el-form-item>
        <el-form-item label="增加余额">
          <el-input
            v-model="form1.addBalance"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请输入金额，不能输入字符串"
          ></el-input>
        </el-form-item>
        <el-form-item label="最低保证金">
          <el-input
            v-model="form1.deposit_need"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请输入金额，不能输入字符串"
          ></el-input>
        </el-form-item>
        <span style="color: #666;line-height: 28px;font-size:14px;">注:该代理是在{{form1.managerPro}}。</span>
        <!-- <el-form-item label="管理的省">
          <el-select
            @change="getProvinceUserList"
            v-model="form1.managerPros"
            placeholder="请选择"
            style="width:100%"
            multiple
          >
            <el-option
              v-for="option in typeOptions"
              :value="option"
              :key='option'
              :label="option"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="下属省级代理">
          <el-select
            v-model="form1.subIds"
            placeholder="请选择"
            multiple
            style="width:100%"
          >
            <el-option
              v-for="item in provinceList"
              :disabled="item.my_status != 1 ? false : true"
              :key="item.user_id"
              :label="item.show_info"
              :value="item.user_id"
            >
              <span style="float: left">{{ item.show_info }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.province }}</span>
            </el-option>
          </el-select>
        </el-form-item>-->

        <el-form-item>
          <el-button type="primary" @click="throwGroupUp1()" :loading="ceoLoading">提交</el-button>
          <el-button @click="dialogCEOVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="修改信息" :visible.sync="editUpInfoDialog" width="40%">
      <el-form label-position="top" class="m-search" size="small" :model="form2" ref="form2">
        <el-form-item v-if="form2.role_type" label="修改哪个">
          <el-select v-model="form2.info_type" placeholder="请选择" :disabled='form2.role_type == -1'>
            <el-option label="上级" value="1"></el-option>
            <el-option label="推荐人" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="form2.role_type > -1 && form2.info_type == 1" label="新上级手机号">
          <el-input
            v-model="form2.up_tel"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请填写新上级手机号，11位"
          ></el-input>
        </el-form-item>
        <el-form-item label="新推荐人手机号" v-if=" form2.info_type == 2">
          <el-input
            v-model="form2.recommend_tel"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请填写新推荐人手机号，11位"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="throwGroupUp11()" :loading="ceoLoading1">提交</el-button>
          <el-button @click="editUpInfoDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="挂等级" :visible.sync="upToolDialog" width="40%">
      <el-form label-position="top" class="m-search" size="small" :model="formTool" ref="formTool">
        

        <el-form-item label="经销商手机号">
          <el-input
            v-model="formTool.upTel"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请填写经销商手机号，11位"
          ></el-input>
        </el-form-item>
        <el-form-item label="董事手机号">
          <el-input
            v-model="formTool.dongTel"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请填写董事手机号，11位"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="throwTool()" :loading="toolLoading">提交</el-button>
          <el-button @click="upToolDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "normal_user_list",
  created() {},
  data() {
    return {
      addRealEditLoading1:false,
      addRealEditLoading:false,
      dialogRealEditVisible:false,
      ceoLoading1: false,
      formTool:{
        upTel:null,
        dongTel:null
      },
      form2: {
        id: null,
        up_tel: null,
        info_type:1,
        recommend_tel: null
      },
      toolLoading:false,
      dialogCEOVisible: false,
      dialogEditVisible: false,
      tableDataLoading: false,
      bankListVisible: false,
      addLoading: false,
      upToolDialog:false,
      addLoading2: false,
      ceoLoading: false,
      bankListVisibleLoading: false,
      searchUserId: null,
      tableData1: [],
      dialogGroupEditVisible:false,
      addGroupLoading:false,
      form: {
        id: null,
        type: "1",
        deposit: null,
        group_type: null,
        telephone:null
      },
      groupForm:{
        id:null,
        groupType:null
      },
      formReal: {
        telephone: null,
        userId: null,
        balance:null,
        identy:null,
        myCode:null,
        tCode:null
      },
      form1: {
        id: null,
        managerPros: [],
        managerPro: null,
        deposit: null,
        deposit_need: null,
        addBalance: null,
        subIds: []
      },
      balanceForm: {
        status: "1",
        money: null,
        id: null
      },
      filters: {
        title: null,
        status: null,
        roleType: null,
        isSu:null,
        groupType:null,
        specialStatus: null,
        provinceType: null,
        user_type: null
      },
      dialogBalanceVisible: false,
      addBalanceLoading: false,
      balanceFormRule: {
        money: [{ required: true, message: "请输入余额", trigger: "blur" }],
        status: [{ required: true, message: "请选择操作类型", trigger: "blur" }]
      },
      isCollapse: true,
      activeName: "second",
      page_num: 1,
      keywords: "",
      tableHeight: null,
      value4: "",
      dialogEditVisible2: false,
      addLoading3:false,
      dialogEditVisible3:false,
      provinceList: [],
      typeOptions: [
        "北京",
        "天津",
        "河北省",
        "山西省",
        "内蒙古自治区",
        "辽宁省",
        "吉林省",
        "黑龙江省",
        "上海",
        "江苏省",
        "浙江省",
        "安徽省",
        "福建省",
        "江西省",
        "山东省",
        "河南省",
        "湖北省",
        "湖南省",
        "广东省",
        "广西壮族自治区",
        "海南省",
        "重庆",
        "四川省",
        "贵州省",
        "云南省",
        "西藏自治区",
        "陕西省",
        "甘肃省",
        "青海省",
        "宁夏回族自治区",
        "新疆维吾尔自治区",
        "台湾",
        "香港特别行政区",
        "澳门特别行政区",
        "钓鱼岛"
      ],
      pickerOptions1: 1,
      value2: "",
      options: ["阿德的", "豆得儿"],
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      provinceOptions:null,
      ppD:null,
      editUpInfoDialog: false
    };
  },
  mounted() {
    //tableHeight
    var provinceList = localStorage.getItem("provinceList")
    if (provinceList && provinceList != null && provinceList != '')
    {
      this.ppD = provinceList;
      this.provinceOptions = provinceList.split(',');
    }
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    changeProvinceType(val){
      if(val){
        this.filters.roleType = "3"
      }
    },
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/app_user_list_excel?token=" +
        localStorage.getItem("api_token");

      if (that.filters.title) {
        url = url + "&keyword=" + that.filters.title;
      }
      if (that.filters.groupType) {
        url = url + "&groupType=" + that.filters.groupType;
      }
      if (that.filters.status) {
        url = url + "&status=" + that.filters.status;
      }
      if (that.filters.specialStatus) {
        url = url + "&specialStatus=" + that.filters.specialStatus;
      }
      var provinceList = localStorage.getItem("provinceList")
      if (that.filters.province && that.filters.province != null) {
        url = url + "&province=" + that.filters.province;
      } else if (provinceList != null) {
        url = url + "&province=" + provinceList;
      }
      if (that.filters.isSu) {
        url = url + "&isSu=" + that.filters.isSu;
      }
      if (that.filters.roleType) {
        url = url + "&roleType=" + that.filters.roleType;
      }
      if (that.filters.provinceType){
        url = url + "&provinceType=" + that.filters.provinceType
      }
      if (that.filters.user_type){
        url = url + "&user_type=" + that.filters.user_type
      }
      // window.open("http://localhost:8839"+url,'_blank')
      top.location.href = url;
    },
    getChangeMoneyI(){

        that.addRealEditLoading1 = true;
        let para = {
          token: localStorage.getItem("api_token"),
          userId: that.formReal.userId
        };
        API.out_total_p(para)
          .then(
            function(result) {
              that.addRealEditLoading1 = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "申请成功",
                  duration: 1500
                });
                that.formReal.tCode = result.result.map.tCode;
                that.formReal.myCode = result.result.map.myCode;
              }
            },
            function(err) {
              that.addRealEditLoading1 = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.addRealEditLoading1 = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
    },
    editUpInfo(row) {
      this.form2.id = row.id;
      this.form2.up_tel = null;
      this.form2.recommend_tel = null;
      
      this.form2.role_type = row.role_type;
      if (this.form2.role_type > -1)
      {
        this.form2.info_type = '1';
      } else {
        this.form2.info_type = '2';
      }
      this.editUpInfoDialog = true;
    },
    handleCommand(command) {},
    addPostDialog() {
      this.$router.push({ path: "/addNormalUser" });
    },
    upTool(){
      this.formTool.upTel = null;
      this.formTool.dongTel = null;
      this.upToolDialog = true;
    },
    companyInfoSet(row) {
      this.$router.push({ path: "/companySet", query: { userId: row.id } });
    },
    changeRealInfo(){

      var that = this;
      if (
        !that.formReal.telephone ||
        that.form1.telephone == null
      ) {
        that.$message.error({
          showClose: true,
          message: "请填写手机号",
          duration: 2000
        });
      } else {
        that.addRealEditLoading = true;
        let para = {
          token: localStorage.getItem("api_token"),
          userId: that.formReal.userId,
          telephone:that.formReal.telephone
        };
        API.again_real_apply(para)
          .then(
            function(result) {
              that.addRealEditLoading = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "申请成功",
                  duration: 1500
                });
                that.dialogRealEditVisible = false;
                that.search();
              }
            },
            function(err) {
              that.addRealEditLoading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.addRealEditLoading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
    }
    },
    goEditPage(row) {
      this.$router.push({ path: "/editNormalUser", query: { good: row } });
    },
    delNormalUser(row) {
      this.$router.push({ path: "/delNormalUser", query: { good: row } });
    },
    downRoleType(row) {
      this.$router.push({ path: "/downRoleType", query: { good: row } });
    },
    setterGroupInfo(row)
    {
      this.groupForm.id = row.id;
      if (row.group_type && row.group_type != null)
      {
        this.groupForm.groupType = row.group_type + "";
      }
      else {
        this.groupForm.groupType = null;
      }
      this.dialogGroupEditVisible = true;
    },
    showEditGroup(row) {
      this.form.id = row.id;
      this.form.deposit = row.deposit_need;
      this.dialogEditVisible = true;
    },
     hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    showChangeRealInfo(row) {
      this.formReal.userId = row.id;
      this.formReal.telephone = row.telephone;
      this.formReal.balance = row.balance;
      this.formReal.tCode = row.tCode;
      this.formReal.myCode = row.myCode;
      this.dialogRealEditVisible = true;
    },
    showEditGroup2(row) {
      this.form.id = row.id;
      this.form.deposit = 0;
      this.dialogEditVisible2 = true;
    },
    showEditGroup3(row) {
      if (row.balance > 0)
      {
        this.$message.error({
            showClose: true,
            message: "余额不能大于0",
            duration: 2000
          });
      }
      else {
        this.form.id = row.id;
        this.form.telephone = null;
        this.dialogEditVisible3 = true;
      }
    },
    showEditGrou1p(row) {
      this.balanceForm.id = row.id;
      this.balanceForm.money = 0;
      this.balanceForm.status = "1";
      this.dialogBalanceVisible = true;
    },
    showEditGroup1(row) {
      let that = this;
      this.form1.id = row.id;
      this.form1.deposit = null;
      this.form1.managerPro = row.province;
      this.form1.deposit_need = row.deposit_need;
      this.form1.addBalance = null;
      //获取省代列表
      // that.ceoLoading = true;
      // this.getProvinceUserList();
      this.dialogCEOVisible = true;
    },
    getProvinceUserList() {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        id: this.form1.id
      };
      if (that.form1.managerPros != null && that.form1.managerPros.length > 0) {
        para.provinces = that.form1.managerPros.join(",");
      }
      API.select_province_list(para)
        .then(
          function(result) {
            that.ceoLoading = false;
            if (result && parseInt(result.key) === 1000) {
              that.provinceList = result.result.list;
              if (that.provinceList != null && that.provinceList.length > 0) {
                var newIds = [];
                for (var i = 0; i < that.provinceList.length; i++) {
                  var hasOne = false;
                  for (var j = 0; j < that.form1.subIds.length; j++) {
                    if (that.form1.subIds[j] == that.provinceList[i].user_id) {
                      hasOne = true;
                      newIds.push(that.provinceList[i].user_id);
                    }
                  }
                  if (!hasOne) {
                    if (that.provinceList[i].my_status == 1) {
                      that.form1.subIds.push(that.provinceList[i].user_id);
                      newIds.push(that.provinceList[i].user_id);
                    }
                  }
                }
                that.form1.subIds = newIds;
              } else {
                that.form1.subIds = [];
              }
            }
          },
          function(err) {
            that.ceoLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.addLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    goDetail(row) {
      this.$router.push({ path: "/user_detail", query: { id: row.id } });
    },
    throwGroupUp2() {
      var that = this;
      that.$refs["balanceForm"].validate(valid => {
        if (valid) {
          if (that.balanceForm.money <= 0) {
            that.$message.error({
              showClose: true,
              message: "操作金额不能小于等于0",
              duration: 2000
            });
            return;
          }
          let para = {
            token: localStorage.getItem("api_token"),
            id: that.balanceForm.id,
            status: that.balanceForm.status,
            money: that.balanceForm.money
          };
          that.addBalanceLoading = true;
          API.change_app_user_balance(para)
            .then(
              function(result) {
                that.addBalanceLoading = false;
                if (result && parseInt(result.key) === 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "操作成功，等待二级审核",
                    duration: 1500
                  });
                  that.dialogBalanceVisible = false;
                  that.search();
                }
              },
              function(err) {
                that.addBalanceLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.addBalanceLoading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    throwGroupUp11() {
      var that = this;
      if (that.form2.role_type == -1)
      {
        if (
        !that.form2.recommend_tel ||
        that.form2.recommend_tel == null
      ) {
        that.$message.error({
          showClose: true,
          message: "请检查是否有信息没有填写",
          duration: 2000
        });
        return;
      }
      }
      else {
        if (
        (!that.form2.up_tel ||
        that.form2.up_tel == null) && that.form2.info_type ==1 
      ) {
        that.$message.error({
          showClose: true,
          message: "请检查是否有信息没有填写",
          duration: 2000
        });
        return;
      }
      if (
        (!that.form2.recommend_tel ||
        that.form2.recommend_tel == null) && that.form2.info_type ==2 
      ) {
        that.$message.error({
          showClose: true,
          message: "请检查是否有信息没有填写",
          duration: 2000
        });
        return;
      }
      }
        that.ceoLoading1 = true;
        let para = {
          token: localStorage.getItem("api_token"),
          id: that.form2.id,
          info_type: 1,
          recommend_tel: that.form2.recommend_tel,
          up_tel: that.form2.up_tel
        };
        API.edit_up_recommend(para)
          .then(
            function(result) {
              that.ceoLoading1 = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "设置成功",
                  duration: 1500
                });
                that.editUpInfoDialog = false;
                that.search();
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message,
                  duration: 2000
                });
              }
            },
            function(err) {
              that.ceoLoading1 = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.addLoading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
    },
    throwTool() {
      var that = this;
      
      if (
        (!that.formTool.upTel ||
        that.formTool.upTel == null) ) {
        that.$message.error({
          showClose: true,
          message: "请检查是否有信息没有填写",
          duration: 2000
        });
        return;
      }
      if (
        (!that.formTool.dongTel ||
        that.formTool.dongTel == null)
      ) {
        that.$message.error({
          showClose: true,
          message: "请检查是否有信息没有填写",
          duration: 2000
        });
        return;
      }
        that.toolLoading = true;
        let para = {
          token: localStorage.getItem("api_token"),
          doTel: that.formTool.dongTel,
          upTel: that.formTool.upTel
        };
        API.change_up_lin(para)
          .then(
            function(result) {
              that.toolLoading = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "提交成功，处理中",
                  duration: 1500
                });
                that.upToolDialog = false;
                that.search();
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message,
                  duration: 2000
                });
              }
            },
            function(err) {
              that.toolLoading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.addLoading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
    },
    throwGroupUp1() {
      var that = this;
      if (
        !that.form1.deposit ||
        that.form1.deposit == null ||
        !that.form1.deposit_need ||
        that.form1.deposit_need == null ||
        !that.form1.addBalance ||
        that.form1.addBalance == null
      ) {
        that.$message.error({
          showClose: true,
          message: "请检查是否有信息没有填写",
          duration: 2000
        });
      } else {
        that.ceoLoading = true;
        let para = {
          token: localStorage.getItem("api_token"),
          id: that.form1.id,
          deposit: that.form1.deposit,
          deposit_need: that.form1.deposit_need,
          addBalance: that.form1.addBalance
          // subIds:that.form1.subIds.join(","),
          // provinces: that.form1.managerPros.join(",")
        };
        API.set_ceo(para)
          .then(
            function(result) {
              that.ceoLoading = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "设置成功",
                  duration: 1500
                });
                that.dialogCEOVisible = false;
                that.search();
              }
            },
            function(err) {
              that.ceoLoading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.addLoading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    throwGroupUp22() {
      var that = this;
      if (!that.form.deposit || that.form.deposit == null) {
        that.$message.error({
          showClose: true,
          message: "请填写保证金",
          duration: 2000
        });
      } else {
        that.addLoading2 = true;
        let para = {
          token: localStorage.getItem("api_token"),
          id: that.form.id,
          type: that.form.type,
          deposit: that.form.deposit
        };
        API.op_deposit(para)
          .then(
            function(result) {
              that.addLoading2 = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "申请成功",
                  duration: 1500
                });
                that.dialogEditVisible2 = false;
                that.search();
              }
            },
            function(err) {
              that.addLoading2 = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.addLoading2 = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    throwGroupUp23() {
      var that = this;
      if (!that.form.telephone || that.form.telephone == null) {
        that.$message.error({
          showClose: true,
          message: "请填写互换用户的手机号",
          duration: 2000
        });
      } else {
        that.addLoading3 = true;
        let para = {
          token: localStorage.getItem("api_token"),
          userId: that.form.id,
          telephone: that.form.telephone
        };
        API.change_tong_info(para)
          .then(
            function(result) {
              that.addLoading3 = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "互换成功",
                  duration: 1500
                });
                that.dialogEditVisible3 = false;
                that.search();
              }
            },
            function(err) {
              that.addLoading3 = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.addLoading3 = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    throwGroupUp() {
      var that = this;
      if (!that.form.deposit || that.form.deposit == null) {
        that.$message.error({
          showClose: true,
          message: "请填写保证金",
          duration: 2000
        });
      } else {
        that.addLoading = true;
        let para = {
          token: localStorage.getItem("api_token"),
          id: that.form.id,
          deposit: that.form.deposit
        };
        API.edit_deposit_need(para)
          .then(
            function(result) {
              that.addLoading = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "修改成功",
                  duration: 1500
                });
                that.dialogEditVisible = false;
                that.search();
              }
            },
            function(err) {
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.addLoading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },

    setterGroupForm() {
      var that = this;
      if (!that.groupForm.groupType || that.groupForm.groupType == null) {
        that.$message.error({
          showClose: true,
          message: "请选择所属团队",
          duration: 2000
        });
      } else {
        that.addGroupLoading = true;
        let para = {
          token: localStorage.getItem("api_token"),
          id: that.groupForm.id,
          groupType: that.groupForm.groupType
        };
        API.set_group_type(para)
          .then(
            function(result) {
              that.addGroupLoading = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "设置成功",
                  duration: 1500
                });
                that.dialogGroupEditVisible = false;
                that.search();
              }
            },
            function(err) {
              that.addGroupLoading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.addGroupLoading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    formatterRoleType(row, column) {
      var word = "";
      if (row.role_type != -1) {
        if (row.su_type == 1)
        {
          word = "束轩-";
        }
      }
      if (row.role_type == -1) {
        word = "无";
      } else if (row.role_type == -0.5) {
        word = "康减系列vip会员";
      } else if (row.role_type == -0.4) {
        word = "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        word = "康减系列荣誉会员";
      } else if (row.role_type == 0) {
        word += "VIP门店";
      } else if (row.role_type == 1) {

        if (row.province_type == 4)
        {
          word += "康减康庭系列联盟店";
        } else if (row.province_type == 5) {
          word += "康颜单项联盟店";
        } else {
          word += "联盟店";
        }
      } else if (row.role_type == 2) {
        word = "市代";
      } else if (row.role_type == 3) {
        if (row.province_type == 1)
        {
          word = "优秀省代";
        } else {
          word = "战略省代";
        }

      } else if (row.role_type == 4) {
        word = "CEO";
      } else if (row.role_type == 1.1) {
        word = "康减系列市代";
      } else if (row.role_type == 2.1) {
        word = "康减系列省代";
      } else if (row.role_type == 3.1) {
        word = "康减系列CEO";
      } else if (row.role_type == 1.05) {
        word += "优秀联盟店";
      } else if (row.role_type == 5) {
        word += "总经销商";
      } else if (row.role_type == 6) {
        word += "销售公司";
      } else if (row.role_type == 2.2) {
        word +=  "合伙人";
      } else if (row.role_type == 4.2) {
        word +=  "董事";
      } else if (row.role_type == 5.1) {
        word +=  "区域总监";
      } else if (row.role_type == 5.2) {
        word +=  "城市加盟商";
      } else if (row.role_type == 4.8) {
        return "经销商";
      }
      if (row.special_status == 2) {
        word = word + "-" + "特殊";
      }
      return word;
    },
    formatterStatus(row, column) {
      var msg = '';
      if (row.status == 1) {
        msg = "可用";
      } else if (row.status == 2) {
        msg = "禁用";
      }
      if (row.del_status == 2)
      {
        msg += '-待销户';
      }
      return msg;
    },

    upHouse(row) {
      this.$router.push({ path: "/up_article", query: { id: row.id } });
    },


    setCeoNew(row, status) {

        let that = this;
        this.$confirm("确定要设置该用户为ceo吗?", "设置成功后退出登录后检查一下数据", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              userId: row.id,
            };
            API.set_p_to_ceo(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "设置成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});

    },



    upHouseStatus(row, status) {
      if (status == 2) {
        let that = this;
        this.$confirm("确定禁用该用户吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              ids: row.id,
              status: status
            };
            API.status_normal_user(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "禁用成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 3) {
        let that = this;
        this.$confirm("密码重置后为手机号后六位", "确定重置密码吗?", {
          type: "info"
        })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.reset_group_pass(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "重置成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 1) {
        let that = this;
        this.$confirm("确定恢复该用户吗?", "提示", { type: "warning" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              ids: row.id,
              status: status
            };
            API.status_normal_user(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "恢复成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 4) {
        let that = this;
        this.$confirm("确定设置该用户为待销户吗?", "提示", { type: "warning" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.set_del_app_user(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "设置成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 5) {
        let that = this;
        this.$confirm("确定设置该用户为正常可用吗?", "提示", { type: "warning" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.back_del_app_user(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "设置成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 6) {
        let that = this;
        this.$confirm("确定设置该用户为战略省代吗?", "提示", { type: "warning" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.up_province_type(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "设置成功",
                      duration: 1500
                    });
                    that.search();
                  } else {
                    that.$message.error({
                      showClose: true,
                      message: result.message,
                      duration: 2000
                    });
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 7) {
        let that = this;
        this.$confirm("确定设置该用户为优秀省代吗?", "提示", { type: "warning" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.up_province_type(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "设置成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 8) {
        let that = this;
        this.$confirm("确定设置该用户为城市加盟商吗?", "提示", { type: "warning" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.set_exec_province(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "设置成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.title) {
        params.keyword = that.filters.title;
      }
      if (that.filters.groupType) {
        params.groupType = that.filters.groupType;
      }
      if (that.filters.status) {
        params.status = that.filters.status;
      }

      if (that.filters.specialStatus) {
        params.specialStatus = that.filters.specialStatus;
      }
      if (that.filters.isSu) {
        params.isSu = that.filters.isSu;
      }
      if (that.filters.roleType) {
        params.roleType = that.filters.roleType;
      }
      if (that.filters.provinceType){
        params.provinceType = that.filters.provinceType
      }
      if (that.filters.user_type){
        params.user_type = that.filters.user_type
      }
      var provinceList = localStorage.getItem("provinceList")
      if (that.filters.province != null && that.filters.province != '')
      {
        params.province = that.filters.province;
      } else if (provinceList != null && provinceList != '')
      {
        params.province = provinceList;
      }
      that.tableDataLoading = true;
      API.normal_user_list(params)
        .then(
          function(result) {
            that.tableDataLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.tableDataLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.tableDataLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/normal_user_list.vue